import React, { useContext, useState } from 'react'
import Layout from 'shared/layouts/Main'
import Page from 'shared/types/Page'
import { roles } from 'consts'
import useInit from './hooks/useInit'
import hasAnyRole from 'shared/utils/hasAnyRole'
import getBrandContent from 'utils/getBrandContent'
import Footer from 'shared/components/Footer'
import Report from 'components/Report'
import ReportFilterBar from 'components/ReportFilterBar'
import { ReactReduxContext } from 'react-redux'
import LayoutSwitcher from 'components/LayoutSwitcher'
import HeaderFilterRoleSelect from 'containers/HeaderFilterRoleSelect'
import useFilterRoleChanged from './hooks/useFilterRoleChanged'
import useLoadReports from './hooks/useLoadReports'
import ChildFilterErrors from 'types/ChildFilterErrors'
import useDisplayChildFilterErrors from 'components/Report/hooks/useDisplayChildFilterErrors'

const ReportPage: React.FunctionComponent = (props) => {
  const [showOverlay, setShowOverlay] = useState<boolean>(true)
  const [dataLoaded, setDataLoaded] = useState<boolean>(false)
  const [reports, setReports] = useState<[]>([])
  const [page, setPage] = useState<Page | false>(false)
  const [pageFilterParams, setPageFilterParams] = useState<any>({})
  const [token, setToken] = useState<string | false>(false)
  const [isLoaded, setIsLoaded] = useState<boolean>(false)
  const [isLoadedReps, setIsLoadedReps] = useState<string>('')
  const [loadedCounterReps, setLoadedCounterReps] = useState<number>(0)
  const [filterRole, setFilterRole] = useState<object | null>(null)
  const [filterChangeTime, setFilterChangeTime] = useState<string | false>(false)

  const [childFilterPageErrors, setChildFilterPageErrors] = useState<ChildFilterErrors>({})
  const [childFilterPageErrorMessage, setChildFilterPageErrorMessage] = useState<string|null>(null)
  const [loadedPageFilterCount, setLoadedPageFilterCount] = useState<null | number>(null)

  const { store } = useContext(ReactReduxContext)

  useInit({
    setPage,
    setReports,
    setToken,
    filterRole,
  })

  useFilterRoleChanged({
    filterRole,
    setPage,
    setToken,
    setReports,
  })

  useLoadReports({
    isLoadedReps,
    reports,
    loadedCounterReps,
    isLoaded,
    setLoadedCounterReps,
    setDataLoaded,
    setShowOverlay,
  })

  useDisplayChildFilterErrors({
    setChildFilterErrorMessage: setChildFilterPageErrorMessage,
    childFilterErrors: childFilterPageErrors
  })

  const setPageFilterParam = (param: string, value?: string | Array<string>) => {
    setPageFilterParams(prevState => {
      if(!Array.isArray(value) && [undefined, null, ''].includes(value)){
        const { [param]: _, ...rest } = prevState;
        return {...rest};
      } else {
        return { ...prevState, [param]: value }
      }
    })
  }


  return (
    <Layout
      footerContent={<Footer />}
      brandContent={getBrandContent()}
      showOverlay={showOverlay}
      showCardHeader={true}
      noCard={true}
      headerInsert={
        <>
          <HeaderFilterRoleSelect
            setShowOverlay={setShowOverlay}
            handleFilterRoleChanged={(filterRole) => {
              setFilterRole(filterRole)
            }}
          />
        </>
      }
      menuBottomInsert={hasAnyRole([roles.superAdmin]) ? <LayoutSwitcher store={store} /> : false}
    >
      <>
        {page && typeof page.id === 'number' && (
          <ReportFilterBar
            id={page.id}
            setFilterParam={setPageFilterParam}
            mode='page'
            isLoaded={setIsLoaded}
            setFilterChangeTime={setFilterChangeTime}
            setChildFilterErrors={setChildFilterPageErrors}
            parentFilterParams={pageFilterParams}
            setLoadedFilterCount={setLoadedPageFilterCount}
          />
        )}

        {page && page.staticContent && (
          <div className='report card static-content'>
            <div className='main card-header'></div>
            <div className='card-body' dangerouslySetInnerHTML={{ __html: page.staticContent }} />
          </div>
        )}

        {typeof page === 'object' &&
          typeof page.id === 'number' &&
          reports &&
          token &&
          reports.map((report: any, index: number) => {
            return (
              <Report
                aisReport={report.aisReport}
                name={report.name}
                height={report.height}
                vslzId={report.vslz_id}
                id={report.id}
                formats={report.formats}
                token={token}
                pageFilterParams={pageFilterParams}
                isPageFilterBarLoaded={isLoaded}
                isLoaded={setIsLoadedReps}
                filterChangeTime={filterChangeTime}
                childFilterPageErrorMessage={childFilterPageErrorMessage}
                loadedPageFilterCount={loadedPageFilterCount}
              />
            )
          })}
      </>
    </Layout>
  )
}

export default ReportPage
